import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-app-order-filter',
    templateUrl: './app-order-filter.component.html',
    styleUrls: ['./app-order-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppOrderFilterComponent implements OnInit {  

  @Input() configData;
  @Input() frmGroup;

  @Output() filterData = new EventEmitter();
  @Output() filterModal = new EventEmitter(); 

  constructor() { }

  ngOnInit() {
    console.log(this.configData);
    console.log(this.frmGroup);
  }  
  getColsClass(cols: number[]) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }
    return colsClass;
  }

  getFormTableControls(){
    return this.frmGroup.controls[this.configData.name]['controls'];                
  }  

  searchOrderList(){
    let obj = this.frmGroup.value.SearchBar[0].SearchFilter[0];    
    Object.keys(obj).forEach(function(prop){
      if(obj[prop] instanceof Date){
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        if(prop === 'toInsertDate') {
          obj[prop].setDate(obj[prop].getDate() + 1);
        }        
        obj[prop] = obj[prop].getDate() + '-' + months[obj[prop].getMonth()] + '-' + obj[prop].getFullYear().toString().substr(-2);        
      }
    });
    this.filterData.emit(obj);        
    this.filterModal.emit(false);
  }

  hideForm(){
    this.filterModal.emit(false);
  }

  formReset(){    
    let form = this.frmGroup.get(this.configData.name).controls[0].controls.SearchFilter.controls[0];
    Object.keys(form.controls).forEach(control=>{
      // console.log(form.controls[control]);
      if(form.controls[control].secondaryText){
        form.controls[control].secondaryText = '';
      }
      if(form.controls[control].locationArray){
        form.controls[control].locationArray = [];
      }
    }, this);
    this.frmGroup.get(this.configData.name).controls[0].reset();
  }
}
